import TomSelect from 'tom-select';

/**
 * Update empty state for multi-select Tom Select instances
 * Shows placeholder text when no items selected, hides when items exist
 */
function updateEmptyState(ts, placeholder) {
    let $empty = ts.control.querySelector('.ts-empty-text');
    const hasItems = ts.items.length > 0;

    if (!hasItems) {
        if (!$empty) {
            $empty = document.createElement('span');
            $empty.className = 'ts-empty-text';
            $empty.textContent = placeholder;
            ts.control.insertBefore($empty, ts.control_input);
        }
        $empty.style.display = '';
    } else if ($empty) {
        $empty.style.display = 'none';
    }
}

/**
 * Initialize a Tom Select instance with consistent styling
 * Handles both single and multi-select with proper placeholder behavior
 *
 * @param {HTMLSelectElement} el - The select element to initialize
 * @param {Object} options - Additional Tom Select options to merge
 * @returns {TomSelect} The initialized Tom Select instance
 */
export function initTomSelect(el, options = {}) {
    if (el.tomselect) return el.tomselect;

    const isMultiple = el.hasAttribute('multiple');
    const placeholder = el.dataset.placeholder || '';

    const baseConfig = {
        allowEmptyOption: true,
        wrapperClass: 'ts-wrapper ts-styled',
        ...options
    };

    if (isMultiple) {
        // Multi-select: use custom empty text instead of placeholder
        // Explicitly disable Tom Select's built-in placeholder
        baseConfig.placeholder = '';
        baseConfig.plugins = baseConfig.plugins || [];
        if (!baseConfig.plugins.includes('remove_button')) {
            baseConfig.plugins.push('remove_button');
        }

        const ts = new TomSelect(el, baseConfig);

        if (placeholder) {
            const update = () => updateEmptyState(ts, placeholder);
            ts.on('item_add', update);
            ts.on('item_remove', update);
            update();
        }

        return ts;
    } else {
        // Single select: use standard placeholder
        if (placeholder) {
            baseConfig.placeholder = placeholder;
        }
        return new TomSelect(el, baseConfig);
    }
}

/**
 * Initialize all select.filter-select elements with image support in options
 * @returns {TomSelect[]} Array of initialized Tom Select instances
 */
export function initFilterSelects(container = document) {
    const instances = [];

    // `select.`: Tom Select copies the select's classes onto its wrapper div, so a second call (bots re-running
    // scripts, #692) would otherwise build a Tom Select on the wrapper and fail in init_textbox
    container.querySelectorAll('select.filter-select').forEach(el => {
        if (el.tomselect) return;

        const ts = initTomSelect(el, {
            render: {
                option: function(data, escape) {
                    const image = data.image ? `<img src="${escape(data.image)}" class="select-icon" width="18" height="18">` : '';
                    return `<div class="ts-option-item">${image}<span>${escape(data.text)}</span></div>`;
                },
                item: function(data, escape) {
                    const image = data.image ? `<img src="${escape(data.image)}" class="select-icon" width="18" height="18">` : '';
                    return `<div class="ts-item-inner">${image}<span>${escape(data.text)}</span></div>`;
                }
            }
        });

        instances.push(ts);
    });

    return instances;
}
